// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_3j_vuNbIx7GVtuRP0iZpaq"};